import React, { useState } from 'react';

import { Typography } from '@mui/material';
import { HeaderBox, PageContainer, StyledButton } from './styled';

import AddSchoolModal from './SchoolModal';

import SchoolListingTable from './SchoolListingTable';
import ToastMessage from '../../components/ToastMessage';
import { SnackbarSeverityType } from '../../enums';

const SchoolListing = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string>('');
  const [snackbar, setSnackbar] = useState({
    show: false,
    severity: SnackbarSeverityType.success,
    message: ''
  });
  const [selectedSchoolId, setSelectedSchoolId] = useState<string | null>(null);

  const handleOpenModal = (type: string, schoolId?: string) => {
    setModalType(type);
    setSelectedSchoolId(schoolId || null);
    setModalOpen(true);
  };
  const handleCloseModal = () => setModalOpen(false);

  return (
    <>
      <PageContainer>
        <HeaderBox>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>
            School Management
          </Typography>
          <StyledButton
            variant='contained'
            onClick={() => handleOpenModal('add')}
          >
            Add New School
          </StyledButton>
        </HeaderBox>

        <SchoolListingTable onEdit={handleOpenModal} />

        <AddSchoolModal
          modalType={modalType}
          open={isModalOpen}
          onClose={handleCloseModal}
          setSnackbar={setSnackbar}
          schoolId={selectedSchoolId}
        />
      </PageContainer>
      <ToastMessage
        open={snackbar.show}
        message={snackbar.message}
        onClose={() => setSnackbar((prev) => ({ ...prev, show: false }))}
      />
    </>
  );
};

export default SchoolListing;
